import React from 'react'
import cn from 'classnames'

import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Button from '@material-ui/core/Button';

const PaginationButton = props => (
	<Button
		variant="outlined"
		className={cn('page-button', {'page-selected': props.selected} )}
		onClick={props.onClick}
	>
		{props.pageIndex + 1}
	</Button>
)

const TablePaginationActions = props => {
	const { page: currPageIndex, rowsPerPage, onChangePage } = props;
	const count = !!props.count ? props.count : 0;
	const totalPage = Math.ceil(count / rowsPerPage);
	const lastPageIndex = totalPage - 1;

	const handleBackButtonClick = event => {
		onChangePage(currPageIndex-1)
	}

	const handleNextButtonClick = event => {
		onChangePage(currPageIndex+1)
	}

	const onClickPageNumber = (newPageIndex) => {
		if(newPageIndex === currPageIndex) return false;
		onChangePage(newPageIndex)
	}

	const renderPageBtn = () => {
		let btn = []
		if(totalPage <= 9){
			for(let i = 0 ; i < totalPage; i++){
				btn.push(i)
			}
		} else {
			let midpage = currPageIndex
			const midMin = 0 + 4;
			const midMax = lastPageIndex - 4;
			if(midpage < midMin){
				midpage = midMin
			} else if (midpage > midMax) {
				midpage = midMax
			}

			const minMidpage = midpage - 2
			const maxMidPage = midpage + 2

			for(let i = minMidpage ; i < maxMidPage+1; i++){
				btn.push(i)
			}
			if (midpage === midMin) {
				btn.unshift(1)
			} else {
				btn.unshift('dot')
			}

			if(midpage === midMax){
				btn.push(lastPageIndex-1)
			} else {
				btn.push('dot')
			}
			btn.unshift(0)
			btn.push(lastPageIndex)
		}

		return btn.map((item, idx) => {
			const key=`pagination-btn-${idx}`
			if (typeof item === 'number') {
				return (
					<PaginationButton
						key={key}
						pageIndex={item}
						selected={currPageIndex === item}
						onClick={() => onClickPageNumber(item)}
					/>
				)
			}
			return <i key={key} className="material-icons">more_horiz</i>
		})
	}

	return (
		<Grid container alignItems="center" className="pagination-action" justify="center">
			<IconButton
				onClick={handleBackButtonClick}
				disabled={currPageIndex === 0}
			>
				<KeyboardArrowLeft/>
			</IconButton>
			{renderPageBtn()}
			<IconButton
				onClick={handleNextButtonClick}
				disabled={currPageIndex >= totalPage - 1}
			>
				<KeyboardArrowRight />
			</IconButton>
		</Grid>
	)
}

export default TablePaginationActions
